import { collection, getDocs, orderBy, query, where } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from '../Admin/Config/Config';

export default function Plan({status, onResult, onClose}) {
    // ================== HANDLING OPEN AND CLOSE MODAL ================== //
    const [isModalOpen, setIsModalOpen] = useState(false);
    useEffect(() => {
      setIsModalOpen(status);
    },[status]);
    const handleClose = () => {
      setIsModalOpen(false);
      onClose();
    }

    // ================== HANDLING FETCHING PLANS ================== //
    const [plans, setPlans] = useState([]);
    const fetchPlans = async () => {
        const ref = collection(db, "bristu_talk_plans");
        const q = query(ref, where("status", "==", true), orderBy("order", "asc"));
        const plansSnap = await getDocs(q);
        const data = [];
        plansSnap.forEach((doc) => {
          data.push({ id: doc.id, ...doc.data() });
        });
        setPlans(data);
    }
    useEffect(() => {
      fetchPlans();
    },[]);

    // ================== HANDLING PLANS ================== //
    const handlePlan = (id) => {
        onResult(id);
        handleClose();
    }
  return (
    <div>
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-2 sm:p-4">
          <div className="bg-white rounded-xl w-full max-w-2xl mx-2 sm:mx-4 shadow-2xl overflow-y-auto max-h-[90vh]">
            <div className="sticky top-0 bg-white z-10 px-4 py-4 sm:p-6 border-b">
              <div className="flex justify-between items-center">
                <div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900">
                    Premium Plans
                  </h3>
                  <p className="text-gray-600 text-xs sm:text-sm mt-0.5 sm:mt-1">Select a plan that suits your learning goals</p>
                </div>
                <button
                  onClick={() => handleClose()}
                  className="text-gray-400 hover:text-gray-600 transition-colors p-1.5 sm:p-2 hover:bg-gray-100 rounded-full"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="px-4 py-4 sm:p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 sm:mb-6">
                {plans &&
                  plans.map((plan) => (
                    <div key={plan.id} className="border-2 rounded-xl p-4 sm:p-5 hover:border-emerald-500 transition-all duration-300 hover:shadow-lg flex flex-col justify-between">
                      <div>
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-4 mb-3">
                          <h4 className="text-base sm:text-lg font-bold text-gray-900">{plan.title}</h4>
                          <span className="bg-emerald-100 text-emerald-600 px-2.5 py-1 rounded-full text-xs sm:text-sm font-medium whitespace-nowrap self-start sm:self-auto">
                            30 mins/day
                          </span>
                        </div>
                        
                        <p className="text-gray-600 text-xs sm:text-sm leading-relaxed mb-4">
                          {plan.desc}
                        </p>

                        <div className="flex items-baseline gap-2 mb-4">
                          <span className="text-xl sm:text-2xl font-bold text-gray-900">₹{plan.offer_price}</span>
                          <div className="flex flex-col">
                            <span className="text-red-500 line-through text-xs sm:text-sm">₹{plan.price}</span>
                            <span className="text-emerald-600 text-xs font-medium">
                              Save ₹{parseFloat(plan.price) - parseFloat(plan.offer_price)}
                            </span>
                          </div>
                        </div>
                      </div>

                      <button
                        onClick={() => handlePlan(plan.id)}
                        className="w-full bg-emerald-600 text-white py-2.5 rounded-lg text-sm sm:text-base font-medium hover:bg-emerald-700 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
                      >
                        Select Plan
                      </button>
                    </div>
                  ))}
              </div>

              <div className="bg-gradient-to-r from-emerald-50 to-emerald-100 p-3 sm:p-4 rounded-lg">
                <div className="flex items-start gap-3">
                  <div className="bg-white p-1.5 rounded-full flex-shrink-0">
                    <svg
                      className="w-3.5 sm:w-4 h-3.5 sm:h-4 text-emerald-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-xs sm:text-sm">Daily Learning Commitment</h4>
                    <p className="text-xs text-gray-600 mt-0.5">Each plan includes 30 minutes of focused learning per day for optimal results.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
